<template>
    <div id="promotionCounselNoPopup">
        <div class="form-wrap" v-show="wX < 1024">
            <div class="form-inner">
                <div class="form">
                    <h4>무료체험 신청하기</h4>
                    <p> 담당자가 빠른 시간내 연락드립니다.</p>
                    <span>필수 입력 사항</span>
                    <table>
                        <tr>
                            <th><span>신청기관명</span></th>
                            <td>
                                <input type="text" class="input-school-name" v-model="schoolName" placeholder="예) 아이런초등학교" @click="sendGtag($event)" />
                            </td>
                        </tr>
                        <tr>
                            <th><span>신청인</span></th>
                            <td>
                                <input type="text" class="input-user-name" v-model="userName" placeholder="성함" @click="sendGtag($event)" />
                            </td>
                        </tr>
                        <tr>
                            <th><span>연락처</span></th>
                            <td>
                                <input type="text" class="input-phone-number" v-model="phoneNumber" placeholder="통화가능한 연락처" @click="sendGtag($event)" />
                            </td>
                        </tr>
                        <tr>
                            <th><span>이메일</span></th>
                            <td>
                                <input type="email" class="input-email" v-model="email" placeholder="자료를 받으실 이메일 주소" @click="sendGtag($event)" />
                            </td>
                        </tr>
                    </table>
                    <dl>
                        <dd>
                            <input type="checkbox" id="g" v-model="letterYn">
                            <label for="g">인공지능 교육흐름 뉴스레터 구독신청</label>
                        </dd>
                    </dl>
                    <div class="btn-wrap" @click="submit()">
                        <span :class="{'disabled' : btnDisabled}">
                            <a><img src="../img/landing_v2/icon-chat.png" width="36" height="auto"/> 신청</a>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "promotionCounselNoPopup",
        data() {
            return {
                schoolName: '',
                userName: '',
                phoneNumber: '',
                email: '',
                trainingPersonnel: '', // 교육 인원
                trainingTime: '', // 교육 시간
                budget: '', // 예산
                fromVal: '', // 알게된 경로
                fromValEtcFlag: false, // 알게된 경로가 '직접 입력' 이면 true
                fromValEtcVal: '', // 직접입력일때 값
                btnDisabled: false,

                radioVal: '',
                activityArea: '',
                letterYn: true,

                resizeTimeout: null,
                wX: 1024,
                showPopupWrap: false,
            };
        },
        created: function() {
        },
        methods: {
            submit(){
                gtag('event', '신청_m1', {
                    'event_category': 'click',
                    'event_label': '신청_m1',
                    'value': '',
                });

                if(!this.btnDisabled) {
                    this.btnDisabled = true;
                } else {
                    return false;
                }

                // console.log(this.radioVal);

                if(this.schoolName === '') {
                    swal("필수 항목 미입력", "'신청기관명'을 입력해주세요.", "error" );
                    this.btnDisabled = false;
                    return false;
                }
                if(this.userName === '') {
                    swal("필수 항목 미입력", "'신청인'을 입력해주세요.", "error" );
                    this.btnDisabled = false;
                    return false;
                } else {
                    // let userNamePattern = /^[ㄱ-ㅎㅏ-ㅣ가-힣]{2,20}$/;
                    // if(!userNamePattern.test(this.userName)) {
                    //     alert('최소 2글자 이상의 한글 이름을 입력해주시기 바랍니다.');
                    //     this.btnDisabled = false;
                    //     return false;
                    // }
                }
                if(this.phoneNumber === '') {
                    swal("필수 항목 미입력", "'연락처'을 입력해주세요.", "error" );
                    this.btnDisabled = false;
                    return false;
                }
                if(this.email === '') {
                    swal("필수 항목 미입력", "'이메일'을 입력해주세요.", "error" );
                    this.btnDisabled = false;
                    return false;
                } else {
                    var emailPattern = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
                    if(!emailPattern.test(this.email)){
                        swal("이메일 형식 오류", "올바른 이메일 형식이 아닙니다.", "error" );
                        this.btnDisabled = false;
                        return false;
                    }
                }

                let parameters = {
                    schoolName: this.schoolName,
                    userName: this.userName,
                    phoneNumber: this.phoneNumber,
                    email: this.email,
                    trainingPersonnel: this.trainingPersonnel,
                    trainingTime: this.trainingTime,
                    budget: this.budget,
                    fromVal: this.fromVal,
                    radioVal: this.getRadioRealValue(),
                    activityArea: this.activityArea,
                    letterYn: this.letterYn ? 'Y' : 'N',
                };

                if(this.fromValEtcFlag) {
                    if(this.fromValEtcVal) {
                        parameters.fromVal = '기타:' + this.fromValEtcVal;
                    }
                }
                // console.log(parameters);

                axios({
                    method : 'POST',
                    url : 'https:\/\/danbee.ai/chatflow/event/v2.0/10b92062-314a-4886-b64b-980fb0a3c228/b676564c-04d8-46ac-8238-23910d46ab76/message.do',
                    headers : {
                        'Content-Type' : 'application/json'
                    },
                    data : JSON.stringify({
                        chatbot_id: '10b92062-314a-4886-b64b-980fb0a3c228',
                        parameters: parameters,
                    })
                }).then((response) => {
                    // console.log('response : ');
                    // console.log(response);
                    swal("접수 완료", "상담신청이 접수되었습니다.", "success" );
                    // alert('상담신청이 접수되었습니다.');
                    this.resetParameters();

                    gtag('event', 'goal', {
                        'event_category': 'click',
                        'event_label': 'goal',
                        'value': '',
                    });
                }).catch((error) => {
                    swal("접수 실패", "오류가 발생했습니다. 관리자에게 문의바랍니다.", "error" );
                    this.btnDisabled = false;
                });
            },
            resetParameters() {
                this.btnDisabled = false;
                this.schoolName = '';
                this.userName = '';
                this.phoneNumber = '';
                this.email = '';
                this.trainingPersonnel = '';
                this.trainingTime = '';
                this.budget = '';
                this.fromVal = '';
                this.fromValEtcVal = '';
                this.fromValEtcFlag = false;
                this.activityArea = '';

                this.showPopupWrap = false;
            },

            getRadioRealValue() {
                switch (this.radioVal) {
                    case 'A':
                        return '교사';
                    case 'B':
                        return '방과후 선생님';
                    case 'C':
                        return '기타';
                    default:
                        return '';
                }
            },
            resizeThrottler(e) {
                if ( !this.resizeTimeout ) {
                    this.resizeTimeout = setTimeout(() => {
                        this.resizeTimeout = null;
                        this.wX = e.target.outerWidth;
                    }, 66);
                }
            },
            sendGtag(e) {
                if(e.target.className) {
                    let event_name = '';
                    if(e.target.className === 'input-school-name') {
                        event_name = '신청기관명 클릭';
                    } else if(e.target.className === 'input-user-name') {
                        event_name = '신청인 클릭';
                    } else if(e.target.className === 'input-phone-number') {
                        event_name = '연락처 클릭';
                    } else if(e.target.className === 'input-email') {
                        event_name = '이메일 클릭';
                    }
                    event_name += '_m1';
                    gtag('event', event_name, {
                        'event_category': 'click',
                        'event_label': event_name,
                        'value': '',
                    });
                }
            },
        },
        mounted() {
            this.wX = window.innerWidth;
            window.removeEventListener("resize", this.resizeThrottler, false);
            window.addEventListener("resize", this.resizeThrottler, false);
        },
        beforeDestroy() {
        },
        destroyed () {
        },
        watch: {
            fromVal: function (val) {
                if (val === '기타') {
                    this.fromValEtcFlag = true;
                } else {
                    this.fromValEtcFlag = false;
                }
            },
        },
        computed: {
        }
    }
</script>



// WEBPACK FOOTER //
// src/counsel_promotion_no_popup.vue